import React from 'react'

import blueCheck from '../../images/check_blue.svg'

import styles from './list-callouts.module.scss'

export default function ListCallouts({ title, callouts }) {
  return (
    <section className={styles.listCallouts}>
      <h2 className={styles.listCalloutsTitle}>{title}</h2>
      <ul className={styles.listCalloutsList}>
        {callouts.map(callout => (
          <li className={styles.listCalloutsItem} key={callout}>
            <img alt="Blue Check Mark" src={blueCheck} />
            {callout}
          </li>
        ))}
      </ul>
    </section>
  )
}
